import { LocalDate } from "@js-joda/core"
import { usePollRef } from "vue-utils"

export const useTodaysDate = () => usePollRef(60_000, () => LocalDate.now())

export const useCurrentYear = () => usePollRef(60_000, () => LocalDate.now().year())
